/**
 * CR V3 Web 观众路由（匿名，无布局）
 */

import type { RouteRecordRaw } from 'vue-router'
import { crV3JoinSessionBeforeEnter } from '@/modules/cr-v3-viewer/router/cr-v3-join-route-guard'

export const crV3ViewerRoute: RouteRecordRaw = {
  path: '/cr-v3/viewer/:code',
  name: 'CrV3Viewer',
  component: () => import('@/modules/cr-v3-viewer/views/CrV3ViewerView.vue'),
  beforeEnter: crV3JoinSessionBeforeEnter,
  props: true,
  meta: {
    title: '智慧课堂',
    requiresAuth: false,
    hidden: true,
  },
}

export default crV3ViewerRoute
